import Box from '@zenbusiness/zui/Box';
import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';

const WrapperContentStyle = ({ theme }) => ({
  width: '100%',
  [theme.breakpoints.up('md')]: {
    maxWidth: '588px'
  }
});

export const WrapperStyle = ({ theme }) => ({
  gridColumn: '1 / 5',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    gridColumn: '1 / 7'
  },
  [theme.breakpoints.up('md')]: {
    gridColumn: '4 / 10'
  }
});

export const WrapperContentStyled = styled(Stack)(WrapperContentStyle);
export const Wrapper = styled(Box)(WrapperStyle);
